import { HttpClient, URL_API } from "../../network";

// type TSubscriptions = {};

class SubscriptionsServiceApi extends HttpClient {
  getListSubscriptions = async (params: TParams) => {
    const data = await this.instance.get(URL_API.SUBSCRIPTION.GET_LIST, {
      params,
    });
    return data;
  };

  createPayment = async (idSubscriptions: string) => {
    const { data } = await this.instance.get(
      URL_API.SUBSCRIPTION.CREATE_PAYMENT +
        `/${idSubscriptions}/payment/mark-as-paid`
    );
    return data;
  };

  deActive = async (idSubscriptions: string) => {
    const { data } = await this.instance.post(
      URL_API.SUBSCRIPTION.DE_ACTIVE + `/deactivate`,
      { subscription_id: idSubscriptions }
    );
    return data;
  };

  active = async (idSubscriptions: string) => {
    const { data } = await this.instance.post(
      URL_API.SUBSCRIPTION.ACTIVE + `/active`,
      { subscription_id: idSubscriptions }
    );
    return data;
  };

  deleteSubscription = async (idSubscription: string) => {
    const { data } = await this.instance.delete(
      URL_API.SUBSCRIPTION.DELETE + `${idSubscription}`
    );
    return data;
  };
}

export const SubscriptionsService = new SubscriptionsServiceApi();
